import DrawData from "./DrawData";

export default class Layer {
    constructor(src?: Partial<Layer>) {
        Object.assign(this, src);
    }
    drawDatas: DrawData[] = [];
    zIndex: number = 0;
}